export const INSPECTION_TYPES = {
    HOME: 'home',
    STORE: 'store'
};

export const INSPECTION_SCREENS = {
    HOME: 'HOME',
    STORE: 'STORE',
    NON_CMC: 'NON_CMC'
};

export const BOOKING_ROUTES = {
    BOOK_APPOINTMENT: '/book-appointment',
    CONFIRMED_APPOINTMENT: '/confirmed-appointment'
};

export const ALLOWED_TYPES = [
    'neighborhood',
    'sublocality_level_5',
    'sublocality_level_4',
    'sublocality_level_3',
    'sublocality_level_2',
    'sublocality_level_1',
    'sublocality',
    'locality'
]; // IN ORDER

export const SHOW_OVERLAY_SEARCH_PARAMS = 'isShowOverlay';

export const Q2B_FLOWS = {
    OPC: 'OPC',
    REVAMP: 'REVAMP',
    OLD: 'OLD'
};

export const CONFIRMATION_BUTTON_ACTIONS = {
    CANCEL: 'CANCEL',
    RESCHEDULE: 'RESCHEDULE'
};

export const APPOINTMENT_ERROR_REASONS = {
    DUPLICATE_BOOKING: 'DUPLICATE_BOOKING',
    NO_TIME_SLOTS: 'NO_TIME_SLOTS',
    API_FAILURE: 'API_FAILURE'
};
